export function getMaxOrganizationsPerAccount(settings) {
    const { maxOrganizationsPerAccount } = settings;
    if (typeof maxOrganizationsPerAccount === 'object') {
        return maxOrganizationsPerAccount.enabled ? maxOrganizationsPerAccount.value : undefined;
    }
    return maxOrganizationsPerAccount;
}
